module.exports = __webpack_public_path__ + "img/full0-min.6a8cce88.png";